import React from 'react'
import PropTypes from 'prop-types'
import {
    Row,
    Col,
    FormGroup,
    Label
} from 'reactstrap'
import DateInput from './DateInput'

import './CleaningHistoryFilter.scss'

class CleaningHistoryFilterButton extends React.Component {

    static propTypes = {
        start: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        end: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        onSelectionChanged: PropTypes.func
    }

    static defaultProps = {
        start: null,
        end: null,
        onSelectionChanged: () => {}
    }

    handleDateInputChange = dateInput => {
        this.props.onSelectionChanged(dateInput)
    }

    render() {
        return (
            <Row className="ao-cleaning-filter">
                <Col md={ 6 }>
                    <FormGroup>
                        <Label for="start">Vanaf</Label>
                        <DateInput
                            name="startdate"
                            date={ this.props.start }
                            onDateChange={ this.handleDateInputChange }
                        />
                    </FormGroup>
                </Col>
                <Col md={ 6 }>
                    <FormGroup>
                        <Label for="end">Tot en met</Label>
                        <DateInput
                            name="enddate"
                            date={ this.props.end }
                            onDateChange={ this.handleDateInputChange }
                        />
                    </FormGroup>
                </Col>
            </Row>
        )
    }
}

export default CleaningHistoryFilterButton
